import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { IoMailUnreadOutline, IoCheckmarkCircleOutline, IoCloseCircleOutline, IoPersonAddOutline, IoArrowBackOutline, IoChevronForwardOutline, IoTimeOutline, IoSendOutline } from 'react-icons/io5'
import style from './Requests.module.css'
import ProfileImage from '../../assests/Profile-PNG-File.png'
import Loader from '../Loder/Loader'
import { baseurl } from '../Url'

const Requests = () => {
  const key = JSON.parse(localStorage.getItem("access-token"));
  const USERID = localStorage.getItem("USERID");
  const navigate = useNavigate();
  const [incomingList, setIncomingList] = useState([]);
  const [sentList, setSentList] = useState([]);
  const [incomingTotalCount, setIncomingTotalCount] = useState(0);
  const [incomingPage, setIncomingPage] = useState(1);
  const [sentTotalCount, setSentTotalCount] = useState(0);
  const [sentPage, setSentPage] = useState(1);
  const INCOMING_PAGE_SIZE = 10;
  const SENT_PAGE_SIZE = 10;
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("received");

  const fetchIncoming = useCallback(async (page = 1) => {
    const response = await fetch(`${baseurl}/user/connection/incoming`, {
      method: "POST",
      body: JSON.stringify({
        user_id: USERID,
        page,
        page_size: INCOMING_PAGE_SIZE,
        limit: INCOMING_PAGE_SIZE,
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    });
    const data = await response.json();
    if (data.status === true) {
      const raw = data.data;
      const rows = Array.isArray(raw)
        ? raw
        : Array.isArray(raw?.results)
          ? raw.results
          : Array.isArray(raw?.items)
            ? raw.items
            : [];
      const totalFromApi =
        Number(data.total_count) ||
        Number(data.total) ||
        Number(raw?.total_count) ||
        Number(raw?.total) ||
        Number(raw?.count) ||
        0;
      const supportsPaging = totalFromApi > rows.length;
      return {
        rows: supportsPaging
          ? rows
          : rows.slice((page - 1) * INCOMING_PAGE_SIZE, page * INCOMING_PAGE_SIZE),
        total: supportsPaging ? totalFromApi : rows.length,
      };
    }
    return { rows: [], total: 0 };
  }, [USERID, key]);

  const fetchOutgoing = useCallback(async (page = 1) => {
    const response = await fetch(`${baseurl}/user/connection/outgoing`, {
      method: "POST",
      body: JSON.stringify({
        user_id: USERID,
        page,
        page_size: SENT_PAGE_SIZE,
        limit: SENT_PAGE_SIZE,
      }),
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${key}`,
      },
    });
    const data = await response.json();
    if (data.status === true) {
      const raw = data.data;
      const rows = Array.isArray(raw)
        ? raw
        : Array.isArray(raw?.results)
          ? raw.results
          : Array.isArray(raw?.items)
            ? raw.items
            : [];
      const totalFromApi =
        Number(data.total_count) ||
        Number(data.total) ||
        Number(raw?.total_count) ||
        Number(raw?.total) ||
        Number(raw?.count) ||
        0;
      const supportsPaging = totalFromApi > rows.length;
      return {
        rows: supportsPaging
          ? rows
          : rows.slice((page - 1) * SENT_PAGE_SIZE, page * SENT_PAGE_SIZE),
        total: supportsPaging ? totalFromApi : rows.length,
      };
    }
    return { rows: [], total: 0 };
  }, [USERID, key]);

  const loadRequests = useCallback(async (incomingPageArg = 1, sentPageArg = 1) => {
    setLoading(true);
    try {
      const [incoming, outgoing] = await Promise.all([
        fetchIncoming(incomingPageArg),
        fetchOutgoing(sentPageArg),
      ]);
      setIncomingList(incoming.rows || []);
      setIncomingTotalCount(incoming.total || 0);
      setSentList(outgoing.rows || []);
      setSentTotalCount(outgoing.total || 0);
    } catch (error) {
      console.error("Error fetching requests:", error);
      setIncomingList([]);
      setIncomingTotalCount(0);
      setSentList([]);
      setSentTotalCount(0);
    } finally {
      setLoading(false);
    }
  }, [fetchIncoming, fetchOutgoing]);

  async function requestAction(connectUserId, action) {
    try {
      const endpoint =
        action === "accept"
          ? `${baseurl}/user/connection/update`
          : `${baseurl}/user/connection/delete`;

      const payload =
        action === "accept"
          ? {
              user_id: USERID,
              connect_user_id: connectUserId,
              action: "accepted",
            }
          : {
              user_id: USERID,
              connect_user_id: connectUserId,
            };

      const response = await fetch(endpoint, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${key}`,
        },
      });
      const data = await response.json();
      if (data.status === true) {
        loadRequests(incomingPage, sentPage);
      }
    } catch (error) {
      console.error("Error processing request:", error);
    }
  }

  useEffect(() => {
    loadRequests(incomingPage, sentPage);
  }, [loadRequests, incomingPage, sentPage]);

  const list = activeTab === "received" ? incomingList : sentList;
  const badgeCount = activeTab === "received" ? incomingList.length : sentList.length;
  const incomingTotalPages = Math.max(1, Math.ceil(incomingTotalCount / INCOMING_PAGE_SIZE));
  const sentTotalPages = Math.max(1, Math.ceil(sentTotalCount / SENT_PAGE_SIZE));

  return (
    <div className={style.PageWrapper}>
    <div className={style.Container}>
      <div className={style.Header}>
        <div className={style.HeaderLeft}>
          <div className={style.HeaderText}>
            <h1 className={style.Title}>Connection Requests</h1>
            <p className={style.Subtitle}>
              {activeTab === "received"
                ? (incomingTotalCount > 0
                    ? `${incomingTotalCount} pending request${incomingTotalCount === 1 ? "" : "s"} waiting for your response`
                    : "Accept or decline pending connection requests")
                : (sentTotalCount > 0
                    ? `${sentTotalCount} request${sentTotalCount === 1 ? "" : "s"} you sent are still pending`
                    : "Track connection requests you have sent")}
            </p>
          </div>
        </div>
        <button className={style.BackLink} onClick={() => navigate("/community")}>
          <IoArrowBackOutline />
          Back to Community
        </button>
      </div>

      <div className={style.TabBar} role="tablist" aria-label="Request type">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "received"}
          className={`${style.Tab} ${activeTab === "received" ? style.TabActive : ""}`}
          onClick={() => setActiveTab("received")}
        >
          Received
          {incomingTotalCount > 0 && (
            <span className={style.TabBadge}>{incomingTotalCount}</span>
          )}
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "sent"}
          className={`${style.Tab} ${activeTab === "sent" ? style.TabActive : ""}`}
          onClick={() => setActiveTab("sent")}
        >
          Sent
          {sentTotalCount > 0 && (
            <span className={style.TabBadgeMuted}>{sentTotalCount}</span>
          )}
        </button>
      </div>

      {loading ? (
        <div className={style.LoaderWrapper}>
          <Loader />
        </div>
      ) : list && list.length > 0 ? (
        <>
          <div className={style.RequestList}>
            {list.map((req, index) => (
              <div
                key={req.user_id || index}
                className={style.RequestCard}
                onClick={() => navigate("/peerprofile", {
                  state: { userID: req.user_id, Role: "" }
                })}
              >
                <div className={style.CardContent}>
                  <div className={style.AvatarWrapper}>
                    <div className={style.Avatar}>
                      <img
                        src={req.profile_image || ProfileImage}
                        alt={req.username}
                        onError={(e) => { e.target.src = ProfileImage; }}
                      />
                    </div>
                    <span className={style.RequestBadge}>
                      {activeTab === "received" ? "Request" : "Pending"}
                    </span>
                  </div>
                  <div className={style.Info}>
                    <h3 className={style.Name}>{req.username}</h3>
                    <span className={style.ViewProfileHint}><IoChevronForwardOutline /> View profile</span>
                  </div>
                </div>
                {activeTab === "received" ? (
                  <div className={style.Actions} onClick={(e) => e.stopPropagation()}>
                    <button
                      className={style.AcceptButton}
                      onClick={() => requestAction(req.user_id, "accept")}
                    >
                      <IoCheckmarkCircleOutline />
                      Accept
                    </button>
                    <button
                      className={style.DeclineButton}
                      onClick={() => requestAction(req.user_id, "decline")}
                    >
                      <IoCloseCircleOutline />
                      Decline
                    </button>
                  </div>
                ) : (
                  <div className={style.SentStatus} onClick={(e) => e.stopPropagation()}>
                    <IoTimeOutline />
                    <span>Waiting for response</span>
                  </div>
                )}
              </div>
            ))}
          </div>
          {activeTab === "received" && incomingTotalCount > INCOMING_PAGE_SIZE && (
            <div className={style.PaginationBar}>
              <button
                type="button"
                className={style.PaginationButton}
                onClick={() => setIncomingPage((p) => Math.max(1, p - 1))}
                disabled={incomingPage === 1}
              >
                Previous
              </button>
              <span className={style.PaginationInfo}>
                Page {incomingPage} of {incomingTotalPages}
              </span>
              <button
                type="button"
                className={style.PaginationButton}
                onClick={() => setIncomingPage((p) => Math.min(incomingTotalPages, p + 1))}
                disabled={incomingPage >= incomingTotalPages}
              >
                Next
              </button>
            </div>
          )}
          {activeTab === "sent" && sentTotalCount > SENT_PAGE_SIZE && (
            <div className={style.PaginationBar}>
              <button
                type="button"
                className={style.PaginationButton}
                onClick={() => setSentPage((p) => Math.max(1, p - 1))}
                disabled={sentPage === 1}
              >
                Previous
              </button>
              <span className={style.PaginationInfo}>
                Page {sentPage} of {sentTotalPages}
              </span>
              <button
                type="button"
                className={style.PaginationButton}
                onClick={() => setSentPage((p) => Math.min(sentTotalPages, p + 1))}
                disabled={sentPage >= sentTotalPages}
              >
                Next
              </button>
            </div>
          )}
        </>
      ) : (
        <div className={style.EmptyState}>
          <div className={style.EmptyIcon}>
            {activeTab === "received" ? <IoPersonAddOutline /> : <IoSendOutline />}
          </div>
          <h3 className={style.EmptyTitle}>
            {activeTab === "received" ? "No pending requests" : "No pending sent requests"}
          </h3>
          <p className={style.EmptyText}>
            {activeTab === "received"
              ? "When someone sends you a connection request, it will appear here."
              : "When you send a connection request, it will appear here until the other person responds."}
          </p>
          <button className={style.BackButton} onClick={() => navigate("/community")}>
            <IoArrowBackOutline />
            Back to Community
          </button>
        </div>
      )}
    </div>
    </div>
  );
};

export default Requests;
